let screenSize = {
    width: window.screen.width,
    height: window.screen.height
}

export const imageToResolution = function(pathIn, windowDimensions) {
  let screenSize = windowDimensions;
  let newPath = "";

  if (screenSize) {
    let extention = pathIn.slice(pathIn.length - 4, pathIn.length);
    //let resolution = pathIn.slice(pathIn.length - 8, pathIn.length-4);
    newPath = pathIn.slice(0, pathIn.length -8);
    if (screenSize) {
      if (screenSize.width <= 768) {
        newPath += "0768" + extention;
      } else if (screenSize.width > 768 && screenSize.width <= 1024) {
        newPath += "1024" + extention;
      } else if (screenSize.width > 1024 && screenSize.width <= 1440) {
        newPath += "1440" + extention;
      } else if (screenSize.width > 1440) {
        newPath += "2560" + extention;
      } else {
        return pathIn;
      }
    }
  }
  return newPath;
}

export const imageToResolutionMobile = function(pathIn, windowDimensions) {
  let screenSize = windowDimensions;
  let newPath = "";

  if (screenSize) {
    let extention = pathIn.slice(pathIn.length - 4, pathIn.length);
    //let resolution = pathIn.slice(pathIn.length - 8, pathIn.length-4);
    newPath = pathIn.slice(0, pathIn.length -8);
    if (screenSize) {
      if (screenSize.width > 375 && screenSize.width <= 425 ) {
        newPath += "0425" + extention;
      } else if (screenSize.width > 320 && screenSize.width <= 375) {
        newPath += "0375" + extention;
      } else if (screenSize.width <= 320) {
        newPath += "320" + extention;
      } else {
        return pathIn;
      }
    }
  }
  return newPath;
}

export const textInResolution = function(tabletStr, laptopStr, laptopLStr, twok, windowDimensions) {
  let screenSize = windowDimensions;
  if (screenSize) {
    if (screenSize.width <= 768) {
      return tabletStr;
    } else if (screenSize.width > 768 && screenSize.width <= 1024) {
      return laptopStr;
    } else if (screenSize.width > 1024 && screenSize.width <= 1440) {
      return laptopLStr;
    } else if (screenSize.width > 1440) {
      return twok;
    }
  }

  return "";
}

export const textInResolutionMobile = function(mobileS, mobileM, mobileL, windowDimensions) {
  let screenSize = windowDimensions;
  if (screenSize) {
    if (screenSize.width <= 320) {
      return mobileS;
    } else if (screenSize.width > 320 && screenSize.width <= 375) {
      return mobileM;
    } else if (screenSize.width >= 376) {
      return mobileL;
    }
  }

  return "";
}

export const parseList = function(listIn) {
  let parseStr = '';
  listIn.forEach && listIn.forEach( (rowX, index) => {
    parseStr += rowX + " | "

    if (index  === (listIn.length - 1)) {
      parseStr = parseStr.slice(0, -1);
    }
  });
  return parseStr;
}

export const screenSizeWithOutMenus = window.screen.height - 65 - 65;
export const paddingForInputs = { paddingLeft: '15px' }


export let loginObj = {
  user: "",
  token: "",
  isLogged: false,
}

export const textNormalSize = textInResolution('medium', 'large', 'x-large', 'x-large', screenSize);